import { atom } from 'recoil';
import { FundingSource } from '@melio/platform-api';

export const fundingSourcesState = atom<FundingSource[] | null>({
  key: 'fundingSourcesState',
  default: null,
});
